"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRegisterResult = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateRegisterResult = (0, validation_1.properties)({
    accessCode: (0, validation_1.text)(),
    email: (0, validation_1.text)(),
    familyName: (0, validation_1.text)(),
    givenName: (0, validation_1.text)(),
    id: (0, validation_1.text)(),
});
//# sourceMappingURL=RegisterResult.js.map